import { atom } from "jotai";

// timezone 감지 실패 시 / SSR 단계에서 사용하는 폴백 IANA TZID.
// `useTimezone()` 의 detect 폴백도 이 값을 그대로 사용한다 — 두 위치가 분리되면
// SSR atom 초기값과 mount 후 detect 폴백이 달라져 hydration 깜빡임이 발생한다.
export const FALLBACK_TIMEZONE = "UTC";

// SSR placeholder. 클라이언트 마운트 직후 useTimezone() 가 실제 IANA TZID 로 갱신한다.
export const timezoneAtom = atom<string>(FALLBACK_TIMEZONE);
